import React from 'react'

import { Button } from 'ui/components/Button'
import { Tooltip } from 'ui/components/Tooltip'

import { useToolbarContext } from './hooks/useToolbarContext'

type ToolbarActionsAddRecordProps = {}

export const ToolbarActionsAddRecord: React.FC<ToolbarActionsAddRecordProps> = () => {
    const { addNewEmptyRecord } = useToolbarContext()

    const isDisabled = !addNewEmptyRecord

    return (
        <Tooltip
            content={isDisabled ? 'Cannot create new records in this table' : undefined}
            zIndex={9999}
        >
            <Button
                size="xs"
                startIcon={{ name: 'Plus' }}
                onClick={addNewEmptyRecord}
                disabled={isDisabled}
            >
                New record
            </Button>
        </Tooltip>
    )
}
